/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum NoteIntercomType {
  AdminReplied = "admin_replied",
  UserCreated = "user_created",
  UserReplied = "user_replied",
  AdminNoted = "admin_noted",
}

export function instanceOfNoteIntercomType(value: any): boolean {
  for (const key in NoteIntercomType) {
    if (Object.prototype.hasOwnProperty.call(NoteIntercomType, key)) {
      if (NoteIntercomType[key as keyof typeof NoteIntercomType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NoteIntercomTypeFromJSON(json: any): NoteIntercomType {
  return NoteIntercomTypeFromJSONTyped(json, false);
}

export function NoteIntercomTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NoteIntercomType {
  return json as NoteIntercomType;
}

export function NoteIntercomTypeToJSON(value?: NoteIntercomType | null): any {
  return value as any;
}

export function NoteIntercomTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): NoteIntercomType {
  return value as NoteIntercomType;
}
